module.exports = __webpack_public_path__ + "images/8efc2cbeddf709840c5df5371608a5e9-trumarketing-logo.png";